
export const redisUrl = process.env.REDIS_URL || 'redis://localhost:6379';
